/**
 * Global Drawer Stack - Public API
 * 
 * Exports all public APIs for the global drawer stack system.
 * Maintains backward compatibility with the original global-drawer-stack.tsx
 */

// Context and Provider
export { GlobalDrawerStackContext, useGlobalDrawerStack } from "./context.js";
export { GlobalDrawerStackProvider } from "./provider.js";

// Components
export { CentralizedDrawer } from "./components/CentralizedDrawer.js";
export { DrawerHeader } from "./components/DrawerHeader.js";
export { DrawerContent } from "./components/DrawerContent.js";

// Hooks
export { useDrawerState } from "./hooks/useDrawerState.js";
export { useDrawerConfig } from "./hooks/useDrawerConfig.js";
export { useTouchGestures } from "./hooks/useTouchGestures.js";
export {
  useMessageDetailDrawer,
  createSpecializedDrawerHook,
} from "./hooks/useSpecializedDrawers.js";

// Types
export type {
  DrawerConfig,
  GlobalDrawerId,
  GlobalDrawerStackContextType,
} from "./types.js";
export { GLOBAL_DRAWER_IDS, DEFAULT_DRAWER_CONFIG } from "./types.js";

// Utilities
export {
  mergeDrawerConfig,
  getDefaultDrawerConfig,
} from "./utils/drawerConfig.js";
export {
  calculateVelocity,
  shouldCloseOnSwipe,
  calculateSwipeOffset,
  type TouchData,
} from "./utils/touchGestures.js";
export {
  mapSideToPosition,
  mapHeightToSize,
  getViewportConstrainedStyles,
} from "./utils/drawerPosition.js";
